/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 9c2.4853 0 4.5-2.0147 4.5-4.5S11.4853 0 9 0 4.5 2.0147 4.5 4.5 6.5147 9 9 9Zm0-1.5c1.6569 0 3-1.3431 3-3 0-1.6568-1.3431-3-3-3s-3 1.3432-3 3c0 1.6569 1.3431 3 3 3ZM15.9607 11.5146a.75.75 0 0 1 .5883.8825L16.2284 14h3.1703l-.3206-1.6029a.75.75 0 0 1 .5884-.8825.7498.7498 0 0 1 .8825.5883L20.9284 14h.9423c.9266 0 1.6925.7223 1.7469 1.6472l.3824 6.5C24.0591 23.1524 23.2599 24 22.253 24h-8.8789c-1.0069 0-1.8061-.8476-1.747-1.8528l.3824-6.5c.0544-.9249.8204-1.6472 1.747-1.6472h.9422l.3794-1.8971a.75.75 0 0 1 .8826-.5883ZM13.7565 15.5a.25.25 0 0 0-.2496.2353l-.3823 6.5a.25.25 0 0 0 .2495.2647h8.8789a.25.25 0 0 0 .2496-.2647l-.3824-6.5a.25.25 0 0 0-.2495-.2353h-8.1142Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M.75 21H9a.75.75 0 0 0 0-1.5H1.5312C1.8776 15.2439 5.1417 12 9 12c.6224 0 1.2263.0833 1.8034.24a.75.75 0 1 0 .3932-1.4475A8.3672 8.3672 0 0 0 9 10.5c-5.0307 0-9 4.428-9 9.75V21h.75Z"
    />
  </React.Fragment>,
  'MenuConsumers'
);
